var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColumnFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333374 1.00016C0.333374 0.631973 0.631851 0.333496 1.00004 0.333496H13C13.3682 0.333496 13.6667 0.631973 13.6667 1.00016C13.6667 1.36835 13.3682 1.66683 13 1.66683H1.00004C0.631851 1.66683 0.333374 1.36835 0.333374 1.00016Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33337 5.00016C2.33337 4.63197 2.63185 4.3335 3.00004 4.3335H11C11.3682 4.3335 11.6667 4.63197 11.6667 5.00016C11.6667 5.36835 11.3682 5.66683 11 5.66683H3.00004C2.63185 5.66683 2.33337 5.36835 2.33337 5.00016Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33337 9.00016C4.33337 8.63197 4.63185 8.3335 5.00004 8.3335H9.00004C9.36823 8.3335 9.66671 8.63197 9.66671 9.00016C9.66671 9.36835 9.36823 9.66683 9.00004 9.66683H5.00004C4.63185 9.66683 4.33337 9.36835 4.33337 9.00016Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnFilter);
export default __webpack_public_path__ + "static/media/ColumnFilter.0323d803dc94492eb88ba294e571be14.svg";
export { ForwardRef as ReactComponent };